import React from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import { observer } from 'mobx-react';

@observer
export default class HrefElement extends React.Component<ExcelTableCellProps, any> {
    render() {
        const { cell, card, className } = this.props;
        const path = cell.getPath();
        const { fieldtype, displayname="", linkaddress, descriptivetext="" } = card.getFieldProps(path);
        let specialFieldDom;
        if (fieldtype == "1") {
            specialFieldDom = <a href={linkaddress} target="_blank" dangerouslySetInnerHTML={{ __html: displayname }}></a>
        } else if (fieldtype == "0" || fieldtype == "2") {   //老表单有type为0的描述性文字
            specialFieldDom = <span dangerouslySetInnerHTML={{ __html: descriptivetext }}></span>;
        }
        return (
            <span className={`specialField ${className}`} ref="specialFieldSpan">{specialFieldDom}</span>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/href-element/index.tsx